import { createApp } from '@app/adapters/create-app'
import CompanyInboxModal from '@app/application/communication/screens/inbox/components/company-inbox-modal.vue'
import createInboxStore from '@app/application/communication/screens/inbox/store/inbox'
import { INBOX_IN_MODAL } from '@app/application/communication/screens/inbox/composables/use-inbox-url-storage'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='company-inbox-modal-trigger']").each(function () {
    this.addEventListener('click', function (e) {
      e.preventDefault()
      openInboxModal(e.currentTarget)
    })
  })
})

function openInboxModal(triggerEl) {
  const portal = document.getElementById('sf-modal-portal')
  if (!portal) return

  if (window.modalCitizen) {
    window.modalCitizen.closeAllModals()
  }

  const mountTarget = document.createElement('div')
  portal.appendChild(mountTarget)

  const endpointParams = {
    companyId: Silverfin.currentCompanyId,
    ledgerId: Silverfin.currentLedgerId(),
    firmId: Silverfin.currentFirmId,
  }

  const app = createApp(CompanyInboxModal, {
    periodName: triggerEl.dataset.periodName || '',
    firmInboxPath: triggerEl.dataset.firmInboxPath,
    onClose() {
      app.unmount()
      mountTarget.remove()
      window.eventHub.$emit('resetNotificationCount')
    },
  })

  const store = createInboxStore(endpointParams)
  app.use(store)
  app.provide(INBOX_IN_MODAL, true)
  app.mount(mountTarget)
}
